<template>
  <div>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="pagination.q"
          append-icon="search"
          label="ค้นหาภาควิชา"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-tooltip left v-if="allowedRoles">
          <v-btn color="deep-orange darken-3" slot="activator" dark fab @click="addItem()">
            <v-icon>playlist_add</v-icon>
          </v-btn>
          <span>เพิ่มภาควิชา</span>
        </v-tooltip>
      </v-card-title>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="items"
        :total-items="pagination.totalItems"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.faculty }}</td>
          <td class="text-xs-left">{{ props.item.department.name }}</td>
          <td class="text-xs-left">{{ props.item.amount }}</td>
          <td class="justify-center layout px-0">
            <v-layout row>
              <v-tooltip left>
                <v-btn icon class="mx-2" slot="activator" @click="viewItem(props.item)">
                  <v-icon color="indigo">pageview</v-icon>
                </v-btn>
                <span>ดูข้อมูล</span>
              </v-tooltip>
              <v-tooltip left v-if="allowedRoles">
                <v-btn icon class="mx-0" slot="activator" @click="onDelete(props.item)">
                  <v-icon color="red">delete</v-icon>
                </v-btn>
                <span>ลบ</span>
              </v-tooltip>
            </v-layout>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ pagination.q }}" found no results.
        </v-alert>
      </v-data-table>

      <div class="text-xs-center pt-2">
        <v-pagination v-model="pagination.page" :length="pages" :total-visible="7"></v-pagination>
      </div>

      <component :is="formDialog" :dialog="dialog" :action="action" :title="title" :item="selectedItem" :allowedRoles="allowedRoles" @dialog="dialog = $event"></component>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import swal from 'sweetalert2'
import sectionDepartmentFormDialog from './formDialog.vue'

export default {
  props:['sectionItem', "allowedRoles"],
  components: {
    sectionDepartmentFormDialog
  },
  data () {
    return {
      action: null,
      dialog: false,
      title: {
        icon: null,
        text: null
      },
      formDialog: null,
      loading: false,
      headers: [
        { text: 'คณะ', align: 'left', sortable: true, value: 'faculty' },
        { text: 'ภาควิชา', align: 'left', sortable: true, value: 'department.name' },
        { text: 'จำนวน น.ศ.', align: 'left', sortable: true, value: 'amount' },
        { sortable: false }
      ],
      pagination: {
        q: '',
        sortBy: '',
        page: 1,
        rowsPerPage: 10,
        descending: true,
        totalItems: 0,
        sectionId: this.sectionItem.id
      },
      items: [],
      selectedItem: {}
    }
  },
  mounted () {
    this.reload()
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },
  methods: {
    addItem () {
      this.reset()
      this.title.icon = 'add'
      this.title.text = 'เพิ่มรายการ'
      this.formDialog = 'section-department-form-dialog'
      setTimeout(()=>{this.dialog = true}, 300)
    },
    back () {
      this.$router.go(-1)
    },
    onDelete (item) {

    },
    viewItem (item) {
      this.selectedItem = item
      this.title.icon = 'pageview'
      this.title.text = 'ข้อมูลรายการ'
      this.formDialog = 'section-department-form-dialog'
      setTimeout(()=>{this.dialog = true}, 300)
    },
    reload () {
      this.loading = true
      this.$store.dispatch('sectionDepartment/loadItemsAsPage', this.pagination)
        .then((response) => {
          console.log('reload setionDepartment:', response.data.items )
          this.pagination.totalItems = response.data.totalItems
          this.items = response.data.items
          this.loading = false
        }).catch((error) => {
          this.loading = false
          swal('Error!', error.message, 'error')
        })
    },
    reset () {
      this.selectedItem = {
        section: { id: this.sectionItem.id },
        department: {}
      }
    }
  },
  watch: {
    'pagination.rowsPerPage' () {
      this.reload()
    },
    'pagination.q' () {
      this.reload()
    },
    'pagination.page' () {
      this.reload()
    },
    'pagination.descending' () {
      this.reload()
    },
    dialog (val) {
      if(!val) {
        setTimeout(()=>{
          this.reset()
          this.formDialog = null
        }, 300)
        this.reload()
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/course/section/shows/department/index.vue